import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { ArrowExpandIcon } from '@calendly/ui/components/icons'
import { Link as CuiLink } from '@calendly/ui/components/link'
import { BodyText } from '@calendly/ui/components/typography'
import { useCallback, useMemo } from 'react'

import { trackEditorOpen } from 'features/event_type_editor'
import { useTrack } from 'hooks/analytics_events/useTrack'

import { AccessInfo } from './access_info'


const EventTypeLink = ({ eventType }) => {
  const { id: eventTypeId, kind, type, pooling_type: poolingType } = eventType || {}
  const track = useTrack()

  const trackEdit = () => {
    trackEditorOpen({
      track,
      destination: 'edit',
      source: 'scheduled events edit event type',
      id: eventTypeId,
      kind,
      type,
      poolingType,
    })
  }

  return (
    <CuiLink
      href={eventType.editPath}
      underline={false}
      target="_blank"
      rel="nofollow"
      onClick={trackEdit}
    >
      {eventType.name}
      <ArrowExpandIcon />
    </CuiLink>
  )
}

export const EventTypeInfo = ({ event }) => {
  const { eventType, pageMembers: eventHosts } = event || {}
  const ETLink = useCallback(() => (eventType ? <EventTypeLink eventType={eventType} /> : null), [eventType])
  const usersWithAccess = useMemo(() => (eventType?.accessGrants ? eventType.accessGrants.filter(
    ({ userUuid }) => userUuid && !eventHosts.some(({ uuid }) => uuid === userUuid)
  ) : []), [eventType?.accessGrants, eventHosts])

  if (!eventType) return null

  return (
    <div>
      {eventType.type === 'StandardEventType' && !eventType.deleted && (
        <BodyText size="medium" color="muted">
          {HtmlParser(I18n.t('publisher.meetings.event_type_info.based_on'), { Link: ETLink })}
        </BodyText>
      )}
      <AccessInfo usersWithAccess={usersWithAccess} />
    </div>
  )
}
